function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgStatusAlert = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm.992 10.25c.097 0 .163.021.202.06.038.041.056.113.056.216v1.948c0 .104-.019.175-.056.216s-.105.06-.202.06h-1.984c-.097 0-.164-.019-.202-.06s-.056-.112-.056-.216v-1.948c0-.103.019-.175.056-.216.038-.039.105-.06.202-.06h1.984zm0-7.25c.097 0 .163.017.202.051.037.034.056.094.056.181l-.21 5.536c0 .087-.018.148-.056.181s-.104.051-.202.051h-1.565c-.096 0-.164-.017-.201-.051s-.056-.094-.056-.181l-.21-5.536c0-.087.018-.147.056-.181.038-.033.104-.051.202-.051h1.984z"
  }));
});
export default SvgStatusAlert;